import type { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

export function Input({ className, ...props }: ComponentProps<"input">) {
	return (
		<input
			className={twMerge(
				"border border-input-border rounded-sm bg-input-background px-3 py-2 placeholder:text-input-placeholder placeholder:text-sm ",
				className,
			)}
			{...props}
		/>
	)
}
